<template>
  <div
    :class="{
      'background-gray':
        this.$route.name == 'Category' || this.$route.name == 'Detail' || this.$route.name == 'ResetPassConfirm' || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap', 
      header: navBar,
      gray1: !navBar,
    }"
    style="transition: 0.2s all"
  >
    <div class="container1">
      <div class="header2">
        <div class="logo d-none d-md-block cursor">
          <router-link tag="img" to="/" src="/image/brand/logo.png" />
        </div>
        <nav id="nav1" class="py-3 flex items-center">
          <router-link
            :class="{
              colorBlue:
                this.$route.name == 'Category' || this.$route.name == 'Detail' || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap',
              colorWhite:
                this.$route.name != 'Category' || this.$route.name != 'Detail' ||  this.$route.name != 'thanks' || this.$route.name != 'telemedicina-diabetes' || this.$route.name != 'DiabetesThanks' || this.$route.name != 'landingMap',
              colorWhite: navBar,
              colorBlue: !navBar || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap',
            }"
            v-show="!isLoggedIn"
            tag="a"
            to="/auth/register"
            class="mx-2"
          >
            REGÍSTRATE
          </router-link>
          <router-link
            :class="{
              colorBlue:
                this.$route.name == 'Category' || this.$route.name == 'Detail' || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap',
              colorWhite:
                this.$route.name != 'Category' || this.$route.name != 'Detail' || this.$route.name != 'thanks' || this.$route.name != 'telemedicina-diabetes' || this.$route.name != 'DiabetesThanks' || this.$route.name != 'landingMap',
              colorWhite: navBar,
              colorBlue: !navBar || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap',
            }"
            v-show="!isLoggedIn"
            tag="a"
            to="/auth/login"
            class="ml-2 mr-4"
          >
            INICIAR SESIÓN
          </router-link>
          <div class="form1" action="">
            <input
              v-model="key_code"
              @keyup.enter="searchCourses"
              id="search"
              type="search"
              placeholder="Buscar cursos"
              autocomplete="off"
            />
            <div @click="searchCourses" class="search-icon">
              <Search
                :class="{
                  colorWhite: navBar,
                  colorBlue: !navBar || this.$route.name == 'thanks' || this.$route.name == 'telemedicina-diabetes' || this.$route.name == 'DiabetesThanks' || this.$route.name == 'landingMap',
                }"
              />
            </div>
          </div>
        </nav>

        <nav id="nav2" class="d-md-none">
          <div class="form1 my-3" action="">
            <div class="col-4">
              <div class="logo d-md-none cursor">
                <router-link tag="img" to="/" src="/image/brand/logo.png" />
              </div>
            </div>
            <div class="col-8">
              <div class="row align-items-center">
                <div class="d-flex col">
                  <input
                    v-model="key_code"
                    @keyup.enter="searchCourses"
                    id="search"
                    class="w-100"
                    type="search"
                    placeholder="Buscar cursos"
                    autocomplete="off"
                  />
                  <div
                    v-show="!subActive"
                    class="w-6 grid place-items-center bg-white rounded-r-lg"
                    @click="
                      subActive = true;
                      menuActive = false;
                    "
                  >
                    <Search class="colorBlue iconSearch" />
                  </div>

                  <Close
                    v-show="subActive"
                    @click="subActive = false"
                    class="colorBlue iconSearch"
                  />
                </div>
                <div
                  class="col-2 pr-0 w-50 flex items-center"
                  @click="
                    menuActive = true;
                    subActive = false;
                    nav = true;
                  "
                >
                  <BurguerMenu />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>

    <!-- menu -->
    <div v-if="nav" class="nav-mobile px-4 pt-4 w-full">
      <section class="flex justify-end mt-2">
        <button @click="nav = !nav">
          <Close />
        </button>
      </section>

      <p class="text-lg font-black mt-3 mb-1">Usuario</p>

      <p
        class="text-sm text-skin-primary py-2.5 border-b boder-skin-border cursor-pointer flex justify-between px-1 items-center"
        @click="setRoute('Login')"
      >
        Iniciar sesion
        <ChevronRight />
      </p>

      <p
        class="text-sm text-skin-primary py-2.5 border-b boder-skin-border cursor-pointer flex justify-between px-1 items-center"
        @click="setRoute('Register')"
      >
        Registro
        <ChevronRight />
      </p>

      <p class="text-lg font-black mt-3 mb-1">Categorias</p>

      <p
        v-for="(cat, index) in categories"
        :key="index"
        class="text-sm text-skin-primary py-2.5 border-b boder-skin-border cursor-pointer flex justify-between px-1 items-center"
        @click="filter(cat.id, cat.name)"
      >
        {{ cat.name }}
        <ChevronRight />
      </p>

      <p
        class="text-sm text-skin-primary py-2.5 border-b boder-skin-border cursor-pointer flex justify-between px-1 items-center"
        @click="getCoursesFree"
      >
        Gratuitos
        <ChevronRight />
      </p>

      <p
        class="text-sm text-skin-primary py-2.5 border-b boder-skin-border cursor-pointer flex justify-between px-1 items-center"
        @click="searchAll"
      >
        Ver todos
        <ChevronRight />
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Search from "../../../v2/src/components/icons/Search.vue";
import Close from "../../../v2/src/components/icons/Close.vue";
import BurguerMenu from "../../../v2/src/components/BurgerMenu.vue";
import ChevronRight from "../../../v2/src/components/icons/ChevronRight.vue";
export default {
  name: "topnav",
  components: {
    Search,
    Close,
    BurguerMenu,
    ChevronRight,
  },
  data() {
    return {
      menuActive: false,
      subActive: false,
      key_code: "",
      nav: false,
      navBar: true,
    };
  },
  created() {
    this.key_code = this.$route.query.q;
    window.addEventListener("scroll", this.getScroll);
  },
  methods: {
    getCoursesFree: function() {
      this.nav = false;
      this.$store.dispatch("course/getExternalAllCourses", {
        proyect_id: process.env.VUE_APP_PROYECT_ID,
        free: 1,
      });
      this.$router.push({
        name: "Category",
        query: { category: "free" },
      });
    },

    filter(id, name) {
      this.nav = false;
      this.subActive = false;
      this.$store.commit("category/SET_CAT", { id, name });
      this.$router.push({
        name: "Category",
        params: {
          slug: name
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, ""),
        },
        query: { category: id },
      });
      this.$store
        .dispatch("course/getAllCourses", {
          category_id: id,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
        })
        .then(() => {
          this.$store.commit("course/SET_KEY", name);
        });
    },

    setRoute(name) {
      this.nav = false;
      this.$router.push({ name: name });
    },
    searchAll() {
      this.nav = false;
      this.$store.dispatch("course/getExternalAllCourses", {
        proyect_id: process.env.VUE_APP_PROYECT_ID,
      });
      this.$router.push({
        name: "Category",
        query: { category: "all" },
      });
    },
    searchCourses() {
      this.nav = false;
      this.subActive = false;
      this.$router.push({
        name: "Category",
        query: {
          category: "search",
          q: this.key_code,
        },
      });
    },
    getScroll() {
      if (this.$route.name == "Category" || this.$route.name == "Detail") {
        return;
      }

      if (window.scrollY > 50) this.navBar = false;
      else this.navBar = true;
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      categories: "category/allCategories",
      car: "shopingCart/getCart",
    }),
  },
};
</script>

<style scoped>
.search-icon {
  background: #a1b6e5;
  height: 34px;
  width: 32px;
  border-radius: 0px 7px 7px 0px;
  align-items: center;
  justify-content: center;
  display: flex;
}

.border-bottom {
  border-bottom: 1px solid #b4b4b4 !important;
}

.cursor {
  cursor: pointer;
}

.menuModal::before {
  position: absolute;
  content: "";
  top: -5px;
  background: #fff;
  width: 10px;
  height: 10px;
  left: 90px;
  border-left: 1px solid hsla(0, 0%, 86.7%, 0.87);
  border-top: 1px solid hsla(0, 0%, 86.7%, 0.87);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.tile {
  cursor: pointer;
  font: normal normal normal 15px/22px Roboto;
  letter-spacing: 0px;
  color: #848484;
}

.tile:hover {
  color: #446daf !important;
}

.nav-mobile {
  overflow: auto;
  overflow-x: hidden;
  z-index: 999;
  height: 100%;
  top: 0;
  position: fixed;
  background: white;
  min-height: 100vh;
  position: fixed;
}

.badge {
  padding: 4px 6px;
}

.gray1 {
  background-color: #dddddd;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  align-items: center;
}

.background-gray {
  background-color: #dddddd;
}

.random {
  position: relative;
  width: 1440px;
  z-index: 9999 !important;
  margin-top: -64px;
}

.animated {
  -webkit-transition: all 0.5s linear;
  -moz-transition: all 0.5s linear;
  transition: all 0.5s linear;
  float: left;
}

@keyframes fade-in {
  from {
    opacity: 0;
    /* transform: scaleX(0); */
  }

  to {
    opacity: 1;
    /* transform: scaleX(1); */
  }
}

@keyframes times-in {
  from {
    opacity: 0;
    right: 50px;
  }

  to {
    opacity: 0.6;
    right: 190px;
  }
}

@keyframes fade-input {
  from {
    opacity: 0.2;
    width: 266px;
    right: 50px;
  }

  to {
    width: 553px;
    right: 185px;
  }
}

@keyframes text-animation {
  0% {
    opacity: 0;
  }

  80% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.introInput {
  animation-name: fade-input;
  transition-timing-function: linear;
  animation-duration: 1s;
}

.introTimes {
  position: absolute;
  top: 13px;
  right: 190px;
  z-index: 999;
  animation-name: times-in;
  animation-duration: 1s;
}

.icon-svg {
  top: 20px;
  left: 1105px;
  width: 30px;
  height: 20px;
  padding-right: 2px;
  opacity: 1;
}

.icon-from {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  opacity: 1;
  font-size: 22px;
  padding-top: 8px;
  padding-left: 8px;
  cursor: pointer;
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.6;
  }
}

.intro {
  animation-name: fade-in;
  animation-duration: 2s;
}

input#from-search {
  font-size: 14px;
  top: 13px;
  right: 185px;
  width: 553px;
  height: 34px;
  background: #ffffff;
  border-radius: 8px;
  border: none;
  color: #446daf;
  padding-left: 5px;
  position: absolute;
  padding-left: 14px;
}

.badge-success {
  background: transparent linear-gradient(35deg, #f08d6a 0%, #de337a 100%) 0% 0%
    no-repeat padding-box;
  border: 1px solid #70707000;
  color: #ffffff;
  opacity: 1;
  font-size: 6px;
}

.search-sub-menu {
  position: absolute;
  top: 60px;
  right: 185px;
  width: 553px;
  height: 147px;
  background: white;
  color: #000000;
  padding: 15px;
  border-radius: 0px 0px 10px 10px;
  z-index: 111;
  display: flex;
  flex-direction: column;
}

input#from-search::placeholder {
  color: #446daf;
  opacity: 0.3;
}

.sub-menu-overlay {
  top: 0px;
  position: absolute;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 110;
  background: #446daf 0% 0% no-repeat padding-box;
  opacity: 0.6;
}

#link4:hover {
  color: #446daf;
}

hr {
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  border: 0.30000001192092896px solid #446daf;
}

.container1 {
  padding: 0px;
  height: 100%;
  width: 100%;
  max-width: 1440px;
  margin: auto;
}

.header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ffffff;
}

.header2 {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.logo img {
  width: 120px !important;
  height: 38px !important;
}

nav {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.font-filter {
  font: normal normal 900 20px/18px Roboto;
}

nav a {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 18px;
  font-weight: bold;
}

.colorWhite {
  color: #ffffff;
}

.colorBlue {
  color: #446daf;
}

.roboto {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  color: #000000;
  opacity: 1;
}

.animate-text {
  animation-name: text-animation;
  animation-duration: 0.6s;
}

.input:focus,
input:focus {
  outline: none;
}

.form1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.cartshop {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  cursor: pointer;
}

.input-search {
  width: 266px;
  display: flex;
  justify-content: center;
  align-items: center;
}

input#search {
  font-size: 8px;
  width: 240px;
  height: 15px;
  background: #ffffff;
  opacity: 1 !important;
  left: 1144px;
  border: none;
  color: #fff;
  padding-left: 14px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

input#search::placeholder {
  color: #fff;
  opacity: 1;
}

.iconSearch {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #446dafe6 0% 0% no-repeat padding-box;
  top: 15px;
  left: 1373px;
  width: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  opacity: 1;
  font-size: 16px;
  cursor: pointer;
}

.form1 i {
  margin-left: 0;
}

.form1 i,
.control {
  margin-left: 0;
}

.icon i {
  font-size: 20px;
}

.btnMenu {
  cursor: pointer;
}

.menu-overlay {
  position: absolute;
  top: 40px;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 110;
  background: rgba(0, 0, 0, 0.4);
}

.menuModal {
  position: fixed;
  top: 60px;
  right: 3%;
  background: white;
  padding: 15px;
  width: 140px;
  border-bottom-left-radius: 10px;
  z-index: 111;
  display: flex;
  flex-direction: column;
  animation-name: fade-in;
  animation-duration: 1s;
}

.badge-pill {
  border-radius: 10rem;
  margin-top: 5px;
  font-size: 10px;
}

.xp-badge-up {
  position: relative;
  top: -40px;
  margin: 0 10px;
}

@media (min-width: 1440px) and (max-width: 2559px) {
  #nav1 {
    display: inline-flex;
    width: fit-content;
    max-width: 700px;
    margin-right: 3%;
  }

  .logo img {
    margin-top: 3px;
    margin-left: 35%;
    z-index: 9999;
  }

  nav a {
    font-size: 16px;
    text-decoration: none;
  }

  .input-search {
    width: 240px;
  }

  input#search {
    font-size: 16px;
    top: 15px;
    width: 266px;
    height: 34px;
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }

  input#search::placeholder {
    color: #ffffff;
    opacity: 1;
  }

  .iconSearch {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
    font-size: 16px;
  }

  .menu-overlay {
    display: none;
  }

  .menuModal {
    display: none;
  }
}

@media (min-width: 1281px) {
  #nav2 {
    display: none;
  }

  #nav1 {
    display: inline-flex;
    width: fit-content;
    max-width: 700px;
    margin-right: 3%;
  }

  .logo img {
    margin-top: 3px;
    margin-left: 35%;
    z-index: 9999;
  }

  nav a {
    font-size: 16px;
    text-decoration: none;
  }

  .input-search {
    width: 240px;
  }

  input#search {
    font-size: 16px;
    top: 15px;
    width: 266px;
    height: 34px;
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }

  input#search::placeholder {
    color: #ffffff;
    opacity: 1;
  }

  .iconSearch {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
    font-size: 16px;
  }

  .menu-overlay {
    display: none;
  }

  .menuModal {
    display: none;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  #nav2 {
    display: none;
  }

  #nav1 {
    display: inline-flex;
    width: fit-content;
    max-width: 700px;
    margin-right: 3%;
  }

  .logo img {
    margin-top: 3px;
    margin-left: 35%;
  }

  nav a {
    font-size: 16px;
  }

  .input-search {
    width: 240px;
  }

  input#search {
    font-size: 16px;
    top: 15px;
    width: 266px;
    height: 34px;
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }

  input#from-search {
    width: 553px;
  }

  .sub-menu-overlay {
    height: 1280px;
  }

  .search-sub-menu {
    position: fixed;
  }

  input#search::placeholder {
    color: #ffffff;
    opacity: 1;
  }

  .iconSearch {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
    font-size: 16px;
  }

  .menu-overlay {
    display: none;
  }

  .menuModal {
    display: none;
  }
}

@media (min-width: 767px) and (max-width: 1024px) {
  #nav2 {
    display: none;
  }

  #nav1 {
    display: inline-flex;
    width: fit-content;
    max-width: 600px;
    margin-right: 2%;
  }

  .logo img {
    margin-top: 3px;
    /* margin-left: 35%; */
  }

  nav a {
    font-size: 16px;
  }

  /*   CONTROL SEARCH COURSES    */

  .input-search {
    width: 240px;
  }

  input#search {
    font-size: 16px;
    top: 15px;
    width: 160px;
    height: 34px;
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }

  input#from-search {
    width: 420px;
    max-width: 420px !important;
  }

  .sub-menu-overlay {
    height: 1024px;
  }

  .search-sub-menu {
    position: fixed;
    /* left: 330px; */
    width: 420px;
    max-width: 420px !important;
  }

  input#search::placeholder {
    color: #ffffff;
    opacity: 1;
  }

  .iconSearch {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
    font-size: 16px;
  }

  .input-search:hover {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 1;
  }

  .menu-overlay {
    display: none;
  }

  .menuModal {
    display: none;
  }
}

@media (min-width: 767px) and (max-width: 1024px) and (orientation: landscape) {
  #nav2 {
    display: none;
  }

  .menu-overlay {
    display: none;
  }

  .menuModal {
    display: none;
  }

  #nav1 {
    display: inline-flex;
    width: fit-content;
    max-width: 600px;
    margin-right: 3%;
  }

  .logo img {
    margin-left: 50px;
    width: 100px !important;
    height: 33px !important;
  }

  nav a {
    font-size: 14px;
  }

  /*   CONTROL SEARCH COURSES    */

  .input-search {
    width: 240px;
  }

  input#search {
    font-size: 16px;
    top: 15px;
    width: 266px;
    height: 34px;
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }

  input#search::placeholder {
    color: #ffffff;
    opacity: 1;
  }

  .iconSearch {
    background: #a1b6e5 0% 0% no-repeat padding-box;
    opacity: 0.6;
    font-size: 16px;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  #topnav1 {
    background: #dddddd;
  }

  #nav1 {
    display: none;
  }

  #nav2 {
    display: inline-block;
    width: 100%;
  }

  .btnMenu {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
  }

  .btnMenu i {
    font-size: 16px;
    cursor: pointer;
  }

  .menuModal a:hover {
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
  }

  .menuModal {
    top: 60px;
    right: 4%;
    width: 113px;
    height: 89px;
  }

  /*   CONTROL DE BUSCAR CURSOS    */
  input#search {
    font-size: 10px;
    top: 7px;
    left: 157px;
    width: 144px;
    height: 26px;
    background: #ffffff 0% 0% no-repeat padding-box;
    opacity: 1;
    color: #446daf;
    padding-left: 14px;
  }

  input#from-search {
    width: 420px;
    height: 34px;
  }

  .sub-menu-overlay {
    /* top: 64px; */
    height: 1024px;
    z-index: 110;
  }

  .search-sub-menu {
    position: fixed;
    top: 50px;
    left: 48px;
    width: calc(75% - 2rem);
    left: calc(19.5% + 1rem);
  }

  input#search::placeholder {
    color: #446daf;
    opacity: 1;
  }

  .input-search {
    width: 130px;
  }

  .iconSearch {
    top: 7px;
    left: 255px;
    width: 13px;
    height: 13px;
    background: #e4e4e4 0% 0% no-repeat padding-box;
    color: #446daf;
    border-radius: 0px 6px 6px 0px;
    opacity: 1;
    font-size: 12px;
    cursor: pointer;
  }

  .form1 i {
    margin-left: 0;
  }

  .logo img {
    margin-top: 0px;
    width: 65px !important;
    height: 20px !important;
  }

  nav a {
    font-size: 10px;
  }

  .menu-overlay {
    position: absolute;
    top: 50px;
    width: 100vw;
    z-index: 110;
    background: #446daf 0% 0% no-repeat padding-box;
    opacity: 0.3;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  #topnav1 {
    background: #dddddd;
  }

  #nav1 {
    display: none;
  }

  #nav2 {
    display: inline-block;
    width: 100%;
  }

  .btnMenu {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
  }

  .btnMenu i {
    font-size: 16px;
    cursor: pointer;
  }

  .menuModal a:hover {
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
  }

  .menu-overlay {
    top: 31px;
  }

  .menuModal {
    top: 60px;
    /* left: 195px; */
    width: 113px;
    right: 32px;
    right: 3%;
    height: 89px;
  }

  /*   CONTROL DE BUSCAR CURSOS    */
  input#search {
    font-size: 8px;
    top: 7px;
    left: 157px;
    width: 200px;
    height: 24px;
    background: #ffffff 0% 0% no-repeat padding-box;
    opacity: 1;
    color: #446daf;
    padding-left: 14px;
  }

  input#search::placeholder {
    color: #446daf;
    opacity: 1;
  }

  .input-search {
    width: 130px;
  }

  .iconSearch {
    top: 7px;
    left: 255px;
    width: 24px;
    height: 24px;
    background: #e4e4e4 0% 0% no-repeat padding-box;
    color: #446daf;
    border-radius: 0px 6px 6px 0px;
    opacity: 1;
    font-size: 12px;
    cursor: pointer;
  }

  .form1 i {
    margin-left: 0;
  }

  .logo img {
    margin-top: 0px;
    width: 65px !important;
    height: 20px !important;
  }

  nav a {
    font-size: 10px;
  }

  .menu-overlay {
    position: absolute;
    top: 50px;
    width: 100vw;
    z-index: 110;
    background: #446daf 0% 0% no-repeat padding-box;
    opacity: 0.6;
  }
}

@media only screen and (max-width: 321px) {
  .search-sub-menu {
    left: calc(12.5% + 1rem) !important;
  }
}

@media only screen and (max-width: 767px) {
  .header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  .form1 {
    width: 100%;
  }

  .btnMenu {
    align-items: flex-end;
    padding-bottom: 10px;
  }

  .xp-badge-up {
    margin: 0 7px;
  }

  .random {
    width: 0px;
  }

  .search-sub-menu {
    position: fixed;
    top: 48px;
    left: 48px;
    width: calc(75% - 1rem);
    left: calc(12.5% + 0.5rem);
  }

  .sub-menu-overlay {
    height: 100vh !important;
    z-index: -10;
  }

  .menu-overlay {
    top: 64px !important;
  }

  .introInput {
    right: calc((100vw - 255px) / 2) !important;
    animation-name: fade-input2;
    transition-timing-function: linear;
    animation-duration: 0.5s;
  }

  #from-search {
    max-height: 30px !important;
    top: 18px !important;
  }

  .introTimes {
    top: 18px;
    font-size: 18px;
    right: calc((100vw - 240px) / 2) !important;
  }

  .search-sub-menu {
    top: 64px;
  }

  .blue-text {
    color: #446daf;
  }

  .tile2 {
    font: normal normal normal 18px/22px Roboto;
  }

  .font-filter {
    font: normal normal normal 16px/18px Roboto;
  }

  @keyframes fade-input2 {
    from {
      opacity: 0.2;
      height: 60px;
      right: 50px;
    }

    to {
      height: 147px;
      right: calc((100vw - 255px) / 2);
    }
  }
}
</style>
